<template>
    <div class="app-box-height w-full flex">
        <div class="w-[20%] h-full border-r p-[16px] flex flex-col items-start gap-y-[4px] text-[#757a80] font-light">
            <span v-bind:class="getActiveClass('Profil')" v-on:click="selectBar('Profil')">Profil</span>
            <span v-bind:class="getActiveClass('Compétences')" v-on:click="selectBar('Compétences')">Compétences</span>
            <!-- <span v-bind:class="getActiveClass('Attendance')" v-on:click="selectBar('Attendance')">Attendance</span> -->
            <span v-bind:class="getActiveClass('Document')" v-on:click="selectBar('Document')">Document</span>
            <span v-bind:class="getActiveClass('Signature')" v-on:click="selectBar('Signature')">Signature</span>
            <span v-bind:class="getActiveClass('Information banque')" v-on:click="selectBar('Information banque')">Information banque</span>
            <span v-bind:class="getActiveClass('Mot de passe')" v-on:click="selectBar('Mot de passe')">Mot de passe</span>
        </div>
        <div class="w-[80%] h-full overflow-y-scroll p-[16px]">
            <template v-if="!isload">
                <div v-if="isActiveVue('Profil')" class="size-full">
                    <UserProfil :user="user"/>
                </div>
                <div v-if="isActiveVue('Signature')" class="size-full">
                    <UserSignature />
                </div>
                <div v-if="isActiveVue('Information banque')" class="size-full">
                    <UserBank :user="user"/>
                </div>
                <div v-if="isActiveVue('Mot de passe')" class="size-full">
                    <UserPassword />
                </div>

                <div v-if="isActiveVue('Document')" class="size-full">
                    <UserDocument />
                </div>

                <div v-if="isActiveVue('Compétences')" class="size-full">
                    <UserCompetence />
                </div>
                
            </template>
            <template v-else>
                <div class="w-full animate-pulse">
                    <div class="flex items-center justify-between mb-[16px]">
                        <div>
                            <div class="h-[35px] w-[150px] rounded-xl bg-gray-100"/>
                            <div class="h-[35px] w-[150px] mt-1 rounded-xl bg-gray-100"/>
                        </div>
                        <div class="flex items-center gap-x-[6px] font-light">
                            <div class="h-[40px] w-[100px] rounded-xl bg-gray-100"/>
                            <div class="h-[40px] w-[100px] rounded-xl bg-gray-100"/>
                        </div>
                    </div>

                    <div class="h-[20px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                    <div class="h-[50px] mb-[16px] w-full rounded-xl bg-gray-100"/>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
// import SecurityVue from "@/components/ui/security/security-vue.vue";
// import ProfilStat from "./profil-stat.vue";
// import {Loader2} from "lucide-vue-next";
import API from "../../service/API.js";
import axios from "axios";
// import ProfilRapport from "./profil-rapport.vue";
// import ProfilDoc from "./profil/profil-doc.vue";
// import ProfilFormation from "./profil-formation.vue";
// import ProfilDocument from "./profil-document.vue";
import UserProfil from "./user/User-profil.vue";
import UserSignature from "./user/User-signature.vue";
import UserDocument from "./user/User-document.vue";
import UserBank from "./user/User-bank.vue";
import UserPassword from "./user/User-password.vue";
import UserCompetence from "./user/User-competence.vue";
import Swal from "sweetalert2";
export default {
    name : "ProfileVue",
    components:{
        UserBank,
        UserProfil,
        UserSignature,
        UserCompetence,
        UserPassword,
        UserDocument,
        
        // Loader2,
        // SecurityVue,
        // ProfilStat,
        // ProfilRapport,
        // ProfilDoc,
        // ProfilFormation,
        // ProfilDocument
    },
    data(){
        return{
            active:"Profil",
            isload : true,
            asSend:false,
            user:{},
            presence:[],
            exception:{
                r:0,
                d:0,
                a:0
            },
            formValue:{
                debut:null,
                fin:null
            },
        }
    },
    mounted(){
        // this.fetchAll();
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            const userId = localStorage.getItem("userId");
            API.get("fetchUser/"+userId)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message);
                this.user = res.data.user;
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(() => (this.isload = false));
        },
        closeProfil(){
            this.$store.dispatch("switchShowProfil",false);
        },
        getActiveClass(libelle){
            return `h-[36px] w-full flex items-center transition-all cursor-pointer px-[12px] rounded-lg hover:bg-[#eff0fd] hover:text-[#585ed9] ${libelle == this.active && "bg-[#eff0fd] text-[#585ed9]"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        isActiveVue(libelle){
            return this.active === libelle;
        },
        getCurrentDate(){
            const date = new Date();
            const years = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2,0);
            const day = date.getDate().toString().padStart(2,0);
            return `${years}-${month}-${day}`;
        },
        fetchAll(action=""){
            if(action) this.asSend = true;
            const currentDate = this.getCurrentDate();
            const formData = new FormData();
            formData.append("start",action ? ((this.formValue.debut ?? this.formValue.fin) ?? currentDate) :currentDate);
            formData.append("end",action ? ((this.formValue.fin ?? this.formValue.debut) ?? currentDate) :currentDate);
            let endpoints = [
                "getUserStatsPresences/"+(localStorage.getItem("userId") ?? this.$store.getters.userId),
                "getUserStatsExceptions/"+(localStorage.getItem("userId") ?? this.$store.getters.userId)
            ];
            axios.all(endpoints.map((endpoint)=>API.post(endpoint,formData)))
            .then((response)=>{
                console.log("Présence : ",response[0].data["data"]);
                this.presence = response[0].data["data"];
                this.exception = response[1].data["data"];
            })
            .catch()
            .finally(()=>{
                if(action){
                    this.asSend = false;
                }
                // this.isload = false;
            })
        }
    },
}
</script>
    <!-- <div class="mb-4">
            <h2 class="text-4xl text-[#2b2b2b]">Mon profil</h2>
    </div> -->
    <!-- <div class="bg-white rounded-lg p-4 mb-3">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-x-1 text-black font-light rounded-md">
                <span v-bind:class="getActiveClass('Sécurité')" v-on:click="selectBar('Sécurité')">Sécurité</span>
                <span v-bind:class="getActiveClass('Statistique')" v-on:click="selectBar('Statistique')">Statistique</span>
                <span v-bind:class="getActiveClass('Rapport')" v-on:click="selectBar('Rapport')">Rapport</span>
                <span v-bind:class="getActiveClass('Mes document')" v-on:click="selectBar('Mes document')">Mes document</span>
                <span v-bind:class="getActiveClass('Formation')" v-on:click="selectBar('Formation')">Formation</span>
                <span v-bind:class="getActiveClass('Identification')" v-on:click="selectBar('Identification')">Identification</span>
            </div>
            <div class="flex items-center gap-x-2">
                    <input type="date" class="p-3 border rounded-md text-black cursor-pointer" v-model="formValue.debut">
                    <input type="date" class="p-3 border rounded-md text-black cursor-pointer" v-model="formValue.fin">
                    <button :disabled="asSend" class="px-5 py-3 rounded-md border text-black" v-on:click="fetchAll('actualise')">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Actualiser</span>
                    </button>
                </div>
        </div>
    </div> -->

        <!-- <div class="p-4 rounded-lg bg-white">
        <div v-if="isActiveVue('Sécurité')" class="w-full h-full">
            <SecurityVue />
        </div>
        <div v-if="isActiveVue('Statistique')" class="w-full h-full">
            <ProfilStat :exception="exception" v-if="!isload"/>
        </div>
        <div v-if="isActiveVue('Rapport')" class="w-full h-full">
            <ProfilRapport :presence="presence" :isload="isload"/>
        </div>
        <div v-if="isActiveVue('Mes document')" class="w-full h-full">
            <ProfilDoc />
        </div>
        <div v-if="isActiveVue('Formation')" class="w-full h-full">
            <ProfilFormation />
        </div>
        <div v-if="isActiveVue('Identification')" class="w-full h-full">
            <ProfilDocument />
        </div>
    </div> -->